import type { QueryKey, UseQueryOptions } from "@tanstack/react-query";
import type { ApiResponse } from "../Types";
import {
  DEFAULT_STALE_TIME,
  LOOKUP_STALE_TIME,
} from "../Constant/AppConstants";

export { DEFAULT_STALE_TIME, LOOKUP_STALE_TIME };

export type ServiceQueryOptions<TData = any> = Omit<
  UseQueryOptions<TData | null, Error, TData | null, QueryKey>,
  "queryKey" | "queryFn"
>;

export const unwrapApiResponse = <TData>(
  res: ApiResponse<TData>,
): TData | ApiResponse<TData> | null => {
  if (!res?.success) {
    return null;
  }

  return res.data ?? res;
};
